import {BaseDTO} from "../../../core/dto/BaseDTO";
import {OrganisationOwnerDTO} from "./OrganisationOwnerDTO";
// import {OrganisationOwnerDTO} from "./OrganisationOwnerDTO";

export enum EnumOrganisationType {
  COMPANY = "COMPANY",
  USER = "USER",
}

export class OrganisationDTO extends BaseDTO{
  id: number;
  name: string;
  owners: OrganisationOwnerDTO[] = [];
  type: EnumOrganisationType;

  constructor() {
    super();
  }

 override bindData(obj: any): void {
    if (obj == null) {
      return;
    }
    super.bindData(obj);
    this.id = obj.id;
    this.name = obj.name;
    this.type = obj.type as EnumOrganisationType;

    if (Array.isArray(obj.owners)) {
      this.owners = obj.owners.map((ownerData: any) => {
        const owner = new OrganisationOwnerDTO();
        owner.bindData(ownerData);
        return owner;
      });
    }
  }
}
